import { memo } from 'react'
import cn from 'classnames'

import { HStack } from '~/shared/ui/HStack'
import { Text } from '~/shared/ui/Text'

import type { ScaleBarProps } from './types'

import styles from './ScaleBar.module.scss'

/** Шкала сферы совместимости: подпись + процент сверху, полоса снизу (спека 01, компонент 33). */
export const ScaleBar = memo(function ScaleBar(props: ScaleBarProps) {
  const { value, label, isMuted = false } = props
  const clamped = Math.min(100, Math.max(0, value))

  return (
    <div className={styles.root}>
      <HStack justify='BETWEEN' align='CENTER'>
        <div className={styles.label}>
          <Text variant='BODY_S' color='PRIMARY'>
            {label}
          </Text>
        </div>
        <div className={styles.value}>
          <Text variant='BODY_S' color='ACCENT'>{`${clamped}%`}</Text>
        </div>
      </HStack>
      <div className={styles.track}>
        <div
          className={cn(styles.fill, isMuted && styles.isMuted)}
          style={{ width: `${clamped}%` }}
        />
      </div>
    </div>
  )
})
